import React from 'react';
import styled from '@emotion/styled';

const LogoDecor = () => (
    <DecorContainer>
        <img src="/page-decor/pale-irad-symbol.svg" className="pale-blue"/>
        <img style={{transform: 'scale(0.8)'}}  src="/page-decor/orange-irad-symbol.svg" className="orange-symbol"/>
        <img style={{transform: 'scale(0.6)'}} src="/page-decor/green-irad-symbol.svg" className="green-symbol"/>
        <img src="/page-decor/blue-irad-symbol.svg" className="blue-symbol"/>
    </DecorContainer>
);

export default LogoDecor;

const DecorContainer = styled.div`
    position: absolute; 
    top: 0;
    left: 0;

    height: 100%;
    width: 100%;
    /* z-index: 2; */

    .pale-blue{
        position: absolute;
        top: 26rem;
        left: 5rem;
    }

    .orange-symbol{
        position: absolute;
        top: 16rem;
        left: 24.75rem;
    }

    .green-symbol{
        position: absolute;
        top: 19rem;
        right: 33.5rem;
    }

    .blue-symbol{
        position: absolute;
        top: 21.5rem;
        right: 8rem;
    }

    @media only screen and (max-width: 768px) {
		display: none;
	}
`;